
















































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";
import { Menu } from "../../modules/Menu";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
  loginId: string
  password: string
};

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
      loginId: "",
      password: "",
    });

    const signinCardClass = computed((): any => {
      return context.root.$store.state.isPhone ? 'b-card-signin-phone' : 'b-card-signin';
    });

    // ログインボタン押下
    const onSubmit = async () => {
      state.errors = [];
      if(state.loginId.length == 0){
        state.errors.push("ログインIDを入力してください。");
        return;
      }

      if(state.password.length == 0){
        state.errors.push("パスワードを入力してください。");
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      await http.post("/api/login", {condition: {login_id: state.loginId, password: state.password}})
        .then(response => {
          executeLogin(response)
        })
        .catch(error=>{
          if (error.response.status == 401) {
            state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
          }
          if (error.response.status == 402) {
            state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
          }
          if (error.response.status == 403) {
            state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
          }
          if (error.response.status == 405) {
            state.errors.push("同時にログインできる人数が上限に達しています。");
          }
          if (error.response.status == 406) {
            state.errors.push("現在メンテナンス中のためログインできません。");
          }
          if (error.response.status == 409) {
            state.errors.push("アカウントが無効になっているためログインできません。");
          }
        });

      context.root.$store.dispatch("hideOverlay");
    }

    // ログイン成功後の後処理
    const executeLogin = (response: any) => {

      // 2段階認証
      if (response.data.two_factor_auth) {
        // ログインIDをstateに保持
        context.root.$store.commit("setOtpLoginId", response.data.otp_login_id);
        context.root.$router.push(`/teacher_site/sign_in_two_factor`).catch(err => {});
        return
      }
      
      // トークン設定
      var token = response.data.user.access_token
      document.cookie = 'access_token=' + token;
      document.cookie = 'smarky_user_id=' + response.data.user.id;

      context.root.$store.commit("setCurrentUser", response.data.user);
      context.root.$store.commit("setViewPoints", response.data.view_points);

      if(response.data.user.role == Common.RoleEnum.DataTransfer){
        context.root.$router.push(`/teacher_site/course_list`).catch(err => {});
      }else if(response.data.user.login_count == 1){
        context.root.$router.push(`/teacher_site/user_edit`).catch(err => {});
      }else if(context.root.$store.getters.isOptionReportActive){
        context.root.$router.push('/teacher_site/sheet_list').catch(err => {});
      }else if(context.root.$store.getters.isOptionLessonActive){
        context.root.$router.push('/teacher_site/lesson_sheet_list').catch(err => {});
      }else{
        context.root.$router.push('/teacher_site/approval_sheet_list').catch(err => {});
      }
    }

    /******************************
     * Googleログイン
     ******************************/

    const googleLogin = async () => {
      context.root.$store.dispatch("showOverlay");
      document.cookie = "api_kind=google_teacher_login";
      await http.post(`/api/google_sessions/create`).then(response => {
        if (response.data.auth_uri) {
          window.location.href = response.data.auth_uri;
        } else {
          state.errors = ["認証URLの取得に失敗しました。"];
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      document.body.style.background = "whitesmoke";
      // @ts-ignore
      context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));
      
      if(context.root.$route.query.error_kind){
        const error_kind = context.root.$route.query.error_kind as string;

        if(error_kind == "user_not_exists"){
          state.errors.push("お試しいただいたGoogleアカウントではログインできません。");
        }else if(error_kind == "mainte"){
          state.errors.push("現在メンテナンス中のためログインできません。");
        }else if(error_kind == "login_failed_not_active"){
          state.errors.push("アカウントが無効になっているためログインできません。");
        }else if(error_kind == "login_failed_count_over"){
          state.errors.push("ログイン失敗回数の制限を超えたためログインできません。管理者に問い合わせてください。");
        }else if(error_kind == "ip_address_error"){
          state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
        }else if(error_kind == "multiple_login_count_over"){
          state.errors.push("同時にログインできる人数が上限に達しています。");
        }else{
          state.errors.push("ログインに失敗しました。予期せぬエラーが発生しました。");
        }
      }
    })

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.background = "white";
    });

    return {
      ...toRefs(state),
      signinCardClass,
      onSubmit,
      googleLogin,
    }
  }
})
